import React, { useState, useEffect, useContext } from "react";
import Rating from "@mui/material/Rating";
import Card from "@mui/material/Card";
import Tooltip from "@mui/material/Tooltip";

import SuiAvatar from "components/SuiAvatar";
import SuiBox from "components/SuiBox";
import SuiTypography from "components/SuiTypography";
import SuiButton from "components/SuiButton";
import { Carousel } from "antd";

import ReadMore from "components/UpStyled/ReadMore";

import moment from "moment";
import api from "services/api";

const Reviews = ({ store }) => {
  const [reviews, setReviews] = useState([]);

  useEffect(() => {
    if (store?.id) {
      retrieveReviews(store.id);
    }
  }, [store]);

  const retrieveReviews = async (id) => {
    try {
      const { data } = await api.notes.listByResource(id);
      setReviews(data?.notes || []);
    } catch (err) {
      console.log(err);
    }
  };

  const formatUser = (user, avatar) => {
    const fullName =
      user.first_name || user.last_name ? `${user.first_name} ${user.last_name}` : user.email;

    return (
      <SuiBox display="flex" alignItems="flex-end" justifyContent="flex-start" gap={1}>
        <SuiBox>
          <SuiAvatar src={avatar} variant="circle" shadow="sm" />
        </SuiBox>
        <SuiBox>
          <SuiBox>
            <SuiTypography variant="label" textTransform="none" color="dark">
              {fullName}
            </SuiTypography>
          </SuiBox>
          <SuiBox>
            <time dateTime={user.created_at}>
              <SuiTypography variant="label" textTransform="none" color="secondary">
                Joined on {moment(user.created_at).format("MMMM yyyy")}
              </SuiTypography>
            </time>
          </SuiBox>
        </SuiBox>
      </SuiBox>
    );
  };

  return (
    <Card sx={{ py: 2 }}>
      <SuiBox>
        {reviews && reviews.length > 0 ? (
          <Carousel
            arrows={true}
            dots={false}
            prevArrow={
              <div>
                <button
                  class="react-multiple-carousel__arrow react-multiple-carousel__arrow--left "
                  type="button"
                ></button>
              </div>
            }
            nextArrow={
              <div>
                <button
                  class="react-multiple-carousel__arrow react-multiple-carousel__arrow--right "
                  type="button"
                ></button>
              </div>
            }
          >
            {reviews.map((r) => (
              <SuiBox sx={{ mx: 2, my: 2, px: 4 }}>
                <SuiBox mb={2}>{formatUser(r?.author)}</SuiBox>
                <SuiBox sx={{ px: 2 }}>
                  <SuiBox display="flex" alignItems="center" gap={1}>
                    <Tooltip
                      placement="top"
                      title={
                        r?.rating > 10
                          ? (r.rating / 20).toFixed(1)
                          : r?.rating
                          ? r.rating.toFixed(1)
                          : 0
                      }
                    >
                      <SuiBox>
                        <Rating
                          name="read-only"
                          readOnly
                          value={
                            r?.rating > 10
                              ? (r.rating / 20).toFixed(1)
                              : r?.rating
                              ? r.rating.toFixed(1)
                              : 0
                          }
                        />
                      </SuiBox>
                    </Tooltip>
                  </SuiBox>
                  <SuiBox mb={1}>
                    <SuiBox>
                      <time dateTime={r.created_at}>
                        <SuiTypography variant="label" textTransform="none" color="secondary">
                          Reviewed on {moment(r.created_at).format("MMMM DD,yyyy")}
                        </SuiTypography>
                      </time>
                    </SuiBox>
                  </SuiBox>
                  <ReadMore
                    sx={{ mb: 1 }}
                    color="secondary"
                    fontWeight="light"
                    textTransform="none"
                    variant="text"
                    limit={500}
                  >
                    {r.value}
                  </ReadMore>
                </SuiBox>
              </SuiBox>
            ))}
          </Carousel>
        ) : (
          <div className="flex items-center h-[100px] w-full border mt-4">
            <div className="text-gray-600 text-xl mx-auto">No Reviews</div>
          </div>
        )}
      </SuiBox>
    </Card>
  );
};

export default Reviews;
